<template>
  <div
    class="header-menu"
    @click="$emit('click')"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'HeaderMenu',
  componentName: 'HeaderMenu',
};
</script>

<style>

</style>
